// Which game this tab has joined. Per tab, so two students sharing a laptop in turn don't inherit each other's seat.

export interface Seat {
  code: string;
  name: string;
  player?: string; // player code, which brings the student's own slime
  pid?: string;
  secret?: string;
}

const KEY = 'gk-seat';

export function loadSeat(): Seat | null {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || 'null');
  } catch {
    return null;
  }
}

export function saveSeat(s: Seat | null) {
  try {
    if (s) sessionStorage.setItem(KEY, JSON.stringify(s));
    else sessionStorage.removeItem(KEY);
  } catch {
    /* private window: a refresh means joining again */
  }
}
